module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.26551",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6797",
      "conversations-error-reporting": "static-1.8070",
      "conversations-internal-pub-sub": "static-1.15159",
      "conversations-internal-schema": "static-1.11789",
      "conversations-message-history": "static-1.10280",
      "conversations-test-sdk": "static-1.9612",
      "conversations-visitor-experience-components": "static-1.19914",
      "head-dlb": "static-1.4210",
      "hs-promise-utils": "static-1.4677",
      "hs-test-utils": "static-1.7148",
      "hubspot-dlb": "static-2.1406",
      "HubStyleTokens": "static-2.10670",
      "I18n": "static-7.1422",
      "jasmine-immutable": "static-1.2116",
      "jasmine-runner": "static-1.5573",
      "quartz": "static-1.5929",
      "react-aria": "static-1.43",
      "react-dlb": "static-1.58",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.29",
      "urlinator": "static-1.3692",
      "viral-links-lib": "static-1.6048",
      "visitor-ui-component-library": "static-1.5340",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3719",
      "atom": "static-1.4302",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.3944",
      "conversations-infrastructure": "static-1.8092",
      "conversations-prop-types": "static-1.6603",
      "conversations-visibility-tools": "static-1.4925",
      "conversations-visitor-message-history": "static-1.18651",
      "cssUtils": "static-1.562",
      "enviro": "static-4.313",
      "flux-actions": "static-1.283",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.3063",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.8459",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.291",
      "raven": "static-3.5037",
      "react": "static-7.151",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15718",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4600",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3529",
      "sanitize-text": "static-1.7304",
      "signup-constants": "static-1.17039",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.472",
      "usage-tracker": "static-1.6616",
      "usage-tracker-core": "static-1.6466",
      "usage-tracker-multi": "static-1.5030",
      "usage-tracker-public": "static-1.6427",
      "visitor-ui-component-library-icons": "static-1.5151",
      "hs-promise-rejection-tracking": "static-1.4568",
      "raven-hubspot": "static-1.5344",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2741",
      "moment": "static-3.26",
      "quartz-core": "static-1.5148",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4054",
      "foundations-components": "static-1.6566",
      "foundations-theming": "static-1.3469",
      "UIComponents": "static-3.7617",
      "cv-backend-services": "static-1.1269",
      "immutable-less": "static-1.3708",
      "conversations-skeleton-state": "static-1.6517",
      "icons": "static-2.593",
      "react-input-autosize": "static-2.17",
      "react-virtualized": "static-2.78",
      "rpc-client-utils": "static-1.3888",
      "ui-images": "static-2.925",
      "permission-components": "static-1.4528",
      "HeadJS": "static-2.605",
      "framer-motion": "static-1.45",
      "hs-test-utils-bend-plugin": "static-1.2259",
      "msw": "static-1.39",
      "testing-library": "static-1.127",
      "i18n-data": "static-1.203",
      "moment-timezone": "static-5.59",
      "jasmine": "static-4.3500",
      "quartz-core-utils": "static-1.2796",
      "signup-ui-url-generator": "static-2.7226",
      "HubStyle": "static-2.10978",
      "sassPrefix": "static-1.137",
      "csstype": "static-1.38",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5033",
      "dispatcher": "static-1.118",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.677",
      "hub-http-shared-msw-handlers": "static-1.7665",
      "hubspotter-http": "static-1.3864",
      "hubspotter-http-shared-msw-handlers": "static-1.7663",
      "mobile-manifest-mixins": "static-1.375",
      "platform-navigation-bootstrap": "static-1.11580",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.333",
      "hs-story-utils": "static-1.8517",
      "bend-plugin-foundations-components": "static-1.2835",
      "floating-ui": "static-1.33",
      "foundations-theming-specialty": "static-1.1186",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.1952",
      "foundations-theming-base": "static-1.2454",
      "ts-schema": "static-1.3389",
      "platform-infra-nav-components": "static-1.6971"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.26551",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6797",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8070",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15159",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11789",
      "conversations-message-history": "/conversations-message-history/static-1.10280",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9612",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.19914",
      "head-dlb": "/head-dlb/static-1.4210",
      "hs-promise-utils": "/hs-promise-utils/static-1.4677",
      "hs-test-utils": "/hs-test-utils/static-1.7148",
      "hubspot-dlb": "/hubspot-dlb/static-2.1406",
      "HubStyleTokens": "/HubStyleTokens/static-2.10670",
      "I18n": "/I18n/static-7.1422",
      "jasmine-immutable": "/jasmine-immutable/static-1.2116",
      "jasmine-runner": "/jasmine-runner/static-1.5573",
      "quartz": "/quartz/static-1.5929",
      "react-aria": "/react-aria/static-1.43",
      "react-dlb": "/react-dlb/static-1.58",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.29",
      "urlinator": "/urlinator/static-1.3692",
      "viral-links-lib": "/viral-links-lib/static-1.6048",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5340",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3719",
      "atom": "/atom/static-1.4302",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.3944",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8092",
      "conversations-prop-types": "/conversations-prop-types/static-1.6603",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4925",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.18651",
      "cssUtils": "/cssUtils/static-1.562",
      "enviro": "/enviro/static-4.313",
      "flux-actions": "/flux-actions/static-1.283",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.8459",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.291",
      "raven": "/raven/static-3.5037",
      "react": "/react/static-7.151",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15718",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4600",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3529",
      "sanitize-text": "/sanitize-text/static-1.7304",
      "signup-constants": "/signup-constants/static-1.17039",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.472",
      "usage-tracker": "/usage-tracker/static-1.6616",
      "usage-tracker-core": "/usage-tracker-core/static-1.6466",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5030",
      "usage-tracker-public": "/usage-tracker-public/static-1.6427",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5151",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4568",
      "raven-hubspot": "/raven-hubspot/static-1.5344",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2741",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.5148",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4054",
      "foundations-components": "/foundations-components/static-1.6566",
      "foundations-theming": "/foundations-theming/static-1.3469",
      "UIComponents": "/UIComponents/static-3.7617",
      "cv-backend-services": "/cv-backend-services/static-1.1269",
      "immutable-less": "/immutable-less/static-1.3708",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6517",
      "icons": "/icons/static-2.593",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-virtualized": "/react-virtualized/static-2.78",
      "rpc-client-utils": "/rpc-client-utils/static-1.3888",
      "ui-images": "/ui-images/static-2.925",
      "permission-components": "/permission-components/static-1.4528",
      "HeadJS": "/HeadJS/static-2.605",
      "framer-motion": "/framer-motion/static-1.45",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2259",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.127",
      "i18n-data": "/i18n-data/static-1.203",
      "moment-timezone": "/moment-timezone/static-5.59",
      "jasmine": "/jasmine/static-4.3500",
      "quartz-core-utils": "/quartz-core-utils/static-1.2796",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7226",
      "HubStyle": "/HubStyle/static-2.10978",
      "sassPrefix": "/sassPrefix/static-1.137",
      "csstype": "/csstype/static-1.38",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5033",
      "dispatcher": "/dispatcher/static-1.118",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.677",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7665",
      "hubspotter-http": "/hubspotter-http/static-1.3864",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7663",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.375",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11580",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.333",
      "hs-story-utils": "/hs-story-utils/static-1.8517",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2835",
      "floating-ui": "/floating-ui/static-1.33",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1186",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1952",
      "foundations-theming-base": "/foundations-theming-base/static-1.2454",
      "ts-schema": "/ts-schema/static-1.3389",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6971"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};